<template>
    <div class="table-logement-proximite">
        <p class="label main_color_text">Logements à proximité du quartier</p>

        <div class="tle-row q-mb-sm">
          <div class="tle-col three-quarter">
            <el-table
              :table="logement_proximite_table"
              :lines-obj="
                active_study.etudeData.gie.sectionDynamiqueMarcheResidentiel
              "
              lines-field="logement_proximite_table"
              lines-box-class="left lefter"
            />
          </div>
          <div class="tle-col one-quarter self-center">
            <information
              title="Voir localisation sur la carte en première page et dernière page"
            />
          </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";


import number from "@/libs/number";
import PageMixin from "@/components/study/editor/pages/page.mixin.js";
import Information from "@/components/global/information";

export default {
	mixins: [PageMixin],
	components: {
		Information,
	},
	computed: {
		...mapGetters([

		]),
		logement_proximite_table_lines () {
			return parseInt(
				this.active_study.etudeData.gie.sectionDynamiqueMarcheResidentiel
					.logement_proximite_table_lines
			);
		},
		logement_proximite_table () {
			const table = {
				head: [],
				body: [],
				config: {
					cols_width: [10, 10, 20, 20, 20, 20],
				},
			};

			table.head.push([
				"Type",
				"N°",
				"Surf. hab.",
				"Prix unitaire",
				"Prix/m²",
				"Période de vente",
			]);

			let mutations = this.active_study.etudeData.cartographie ? this.active_study.etudeData.cartographie.selected_mutations ? this.active_study.etudeData.cartographie.selected_mutations : [] : [];
			mutations = this.active_study.etudeData.cartographie.hard_coded_programs ? [...mutations, ...this.active_study.etudeData.cartographie.hard_coded_programs.filter(hc => hc.prog_type=="vente")] : mutations;
			mutations.forEach((mut, i) => {
				let type;
				if(mut.properties){
					if(mut.properties.nbapt1pp || mut.properties.nbmai1pp) {
						type = "T1";
					} else if(mut.properties.nbapt2pp || mut.properties.nbmai2pp) {
						type = "T2";
					} else if(mut.properties.nbapt3pp || mut.properties.nbmai3pp) {
						type = "T3";
					} else if(mut.properties.nbapt4pp || mut.properties.nbmai4pp) {
						type = "T4";
					} else if(mut.properties.nbapt5pp || mut.properties.nbmai5pp) {
						type = "T5";
					}
				}else{
					type = mut.type;
				}
				const sbati = mut.properties ? mut.properties.sbati : mut.sbati;
				const valeurfonc = mut.properties ? mut.properties.valeurfonc : mut.valeurfonc;
				
				table.body.push([
					type,
					i + 1,
					{
						value: number.format(sbati, 0),
						suffix: " m²",
					},
					{
						// value: number.format(mut.properties.valeurfonc, 0),
						value: Math.round(valeurfonc/1000)*1000,
						suffix: " €",
					},
					{
						// value: number.format(mut.properties.valeurfonc / mut.properties.sbati, 0),
						value: Math.round((valeurfonc/sbati)/10)*10,
						suffix: " €",
					},
					mut.properties ? mut.properties.anneemut : mut.anneemut,
				]);
			});
			
			return table;
		}
	}
};
</script>